<template>
  <div class="container pt-5">
    <div class="row mb-5">
      <div class="col-lg-4">
        <div class="card border p-3 mb-5">
          <h2 class="text-primary">訂單明細</h2>
          <hr class="bg-primary">
          <h4 class="mb-1">下單日期：</h4>
          <h5 class="mb-4">{{ $filter.date(data.create_at) }}</h5>
          <h4 class="mb-1">電子信箱：</h4>
          <h5 class="mb-4">{{user.email}}</h5>
          <h4 class="mb-1">用戶名稱：</h4>
          <h5 class="mb-4">{{user.name}}</h5>
          <h4 class="mb-1">用戶電話：</h4>
          <h5 class="mb-4">{{user.tel}}</h5>
          <h4 class="mb-1">寄送地址：</h4>
          <h5 class="mb-4">{{user.address}}</h5>
        </div>
      </div>
      <div class="col-lg-8">
        <div class="card border p-3 mb-5">
          <h2 class="text-primary">訂單明細</h2>
          <hr class="bg-primary">
          <div v-for="(item,index) in products"
              :key="index"
              class="mb-3">
              <div class="row">
                <div class="col-lg-2 col-4">
                  <img :src="item.product.imageUrl">
                </div>
                <div class="col-lg-10 col-8">
                  <h5 class="mb-md-5 mb-3">{{ item.product.title }}</h5>
                  <div class="row">
                    <div class="col-md-8 col-12 text-end">
                      <h4>數量：{{ item.qty }} {{ item.product.unit }}</h4>
                    </div>
                    <div class="col-md-4 col-12 text-end">
                      <h4>總價：{{ item.final_total }} 元</h4>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <hr class="bg-primary">
          <h4 class="text-end text-primary">總共：{{ data.total }} 元</h4>
          <div class="text-end">
            <div @click="payOrder()"
                 v-if="this.status"
                 class="btn btn-primary">付款</div>
            <div v-else>
              <h3 class="text-primary">此訂單已完成付款</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: {},
      user: {},
      products: [],
      status: 1
    }
  },
  methods: {
    getData () {
      const api = `${process.env.VUE_APP_API}/api/${process.env.VUE_APP_PATH}/order/${this.$route.params.id}`
      this.$http.get(api).then((res) => {
        console.log(res.data.order)
        this.data = res.data.order
        this.user = res.data.order.user
        this.products = res.data.order.products
      })
    },
    payOrder () {
      const api = `${process.env.VUE_APP_API}/api/${process.env.VUE_APP_PATH}/pay/${this.$route.params.id}`
      this.$http.post(api).then((res) => {
        console.log(res)
        if (res.data.success) {
          this.status = 0
        }
      })
    }
  },
  created () {
    this.getData()
  }
}
</script>
